import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import { InputCheckBox } from "@itandi/itandi-bb-ui/InputCheckBox";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import type { ChangeEvent } from "react";
import { useState } from "react";
import type { Deal } from "~/models/Deal";
import type { DealVendorCompany } from "~/models/DealVendorCompany";
import { isSuccess } from "~/utils/api/api_handler";
import { update } from "~/utils/api/deals/DealVendorCompany";

type Props = DeepReadonly<{
	deal: Deal;
	dealVendor: DealVendorCompany;
	handleClose: () => void;
	mutateDeal: () => Promise<unknown>;
}>;

/**
 * 管理会社がoriginのDealVendorCompanyを更新するためのModal
 *
 * @constructor
 * @for client
 */
export function DealOriginVendorClientChangeModal({
	deal,
	dealVendor,
	handleClose,
	mutateDeal
}: Props) {
	const { notify } = useNotification();
	const [checked, setChecked] = useState(dealVendor.showTenant);

	const onShowTenantChange = (e: ChangeEvent<HTMLInputElement>) => {
		setChecked(e.target.checked);
	};

	const handleSubmit = async () => {
		const response = await update(deal.id, dealVendor.id, {
			showTenant: checked
		});
		if (isSuccess(response)) {
			await mutateDeal();
			notify({ content: "更新しました。", variant: "success" });
			handleClose();
		} else {
			notify({ content: "エラーが発生しました。", variant: "error" });
		}
	};

	return (
		<Modalv2 isOpen onClose={handleClose}>
			<ModalHeader title="案件依頼先情報変更" />
			<ModalBody>
				<FormGroup variant="vertical">
					<FormControl label="個人情報公開">
						<InputCheckBox
							checked={checked}
							label="案件依頼先に個人情報を公開する"
							onChange={onShowTenantChange}
						/>
					</FormControl>
				</FormGroup>
				{checked ? (
					<Alertv2 mt={designTokens["spacing/m"]} variant="warning">
						<Paragraph>
							公開すると、案件依頼先に個人情報を含む資料が表示されます。
						</Paragraph>
					</Alertv2>
				) : null}
			</ModalBody>
			<ModalFooter
				leftArea={
					<Buttonv2 onClick={handleClose} variant="secondary">
						キャンセル
					</Buttonv2>
				}
				rightArea={
					<Buttonv2 onClick={handleSubmit} variant="primary">
						保存
					</Buttonv2>
				}
			/>
		</Modalv2>
	);
}
